import React from 'react';

const SuggestRefreshGraphic = (props: { [key: string]: any }) => {
  return (
    <svg viewBox="0 0 130 136" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="65" cy="70" r="65" fill="#F4F7FC" fillRule="nonzero" />
        <g fillRule="nonzero">
          <path
            fill="#EDF1FA"
            d="M39.6 6.6H42.5V122H39.6z"
            transform="translate(24 5)"
          />
          <g transform="translate(24 5) translate(0 17)">
            <path
              fill="#EDF1FA"
              d="M76.9.3H5.1C2.7.3.8 2.2.8 4.6v7.3c0 2.4 1.9 4.3 4.3 4.3h71.8c2.4 0 4.3-1.9 4.3-4.3V4.6c0-2.3-1.9-4.3-4.3-4.3z"
            />
            <circle cx="9.2" cy="8.3" r="4" fill="#DFE6F8" />
            <path fill="#DFE6F8" d="M18.2 5.8H76.2V10.8H18.2z" />
          </g>
          <g>
            <path
              fill="#EDF1FA"
              d="M30 0C19.3 0 9.2 2.6.3 7.2h59.4C50.8 2.6 40.7 0 30 0z"
              transform="translate(24 5) translate(11)"
            />
            <path
              fill="#DFE6F8"
              d="M30 0c-5.2 0-10.2.6-15 1.8h30C40.2.6 35.2 0 30 0z"
              transform="translate(24 5) translate(11)"
            />
          </g>
          <g transform="translate(24 5) translate(0 43)">
            <path
              fill="#EDF1FA"
              d="M76.9.3H5.1C2.7.3.8 2.2.8 4.6v7.3c0 2.4 1.9 4.3 4.3 4.3h71.8c2.4 0 4.3-1.9 4.3-4.3V4.6c0-2.3-1.9-4.3-4.3-4.3z"
            />
            <circle cx="9.2" cy="8.3" r="4" fill="#DFE6F8" />
            <path fill="#DFE6F8" d="M18.2 5.8H76.2V10.8H18.2z" />
          </g>
          <g transform="translate(24 5) translate(0 69)">
            <path
              fill="#EDF1FA"
              d="M76.9.3H5.1C2.7.3.8 2.2.8 4.6v7.3c0 2.4 1.9 4.3 4.3 4.3h71.8c2.4 0 4.3-1.9 4.3-4.3V4.6c0-2.3-1.9-4.3-4.3-4.3z"
            />
            <circle cx="9.2" cy="8.3" r="4" fill="#DFE6F8" />
            <path fill="#DFE6F8" d="M18.2 5.8H76.2V10.8H18.2z" />
          </g>
          <g transform="translate(24 5) translate(0 95)">
            <path
              fill="#EDF1FA"
              d="M76.9.3H5.1C2.7.3.8 2.2.8 4.6v7.3c0 2.4 1.9 4.3 4.3 4.3h71.8c2.4 0 4.3-1.9 4.3-4.3V4.6c0-2.3-1.9-4.3-4.3-4.3z"
            />
            <circle cx="9.2" cy="8.3" r="4" fill="#DFE6F8" />
            <path fill="#DFE6F8" d="M18.2 5.8H76.2V10.8H18.2z" />
          </g>
          <g>
            <path
              fill="#EDF1FA"
              d="M33 9C44.8 9 55.9 5.8 65.4.3H.6C10.1 5.8 21.2 9 33 9z"
              transform="translate(24 5) translate(8 121)"
            />
            <path
              fill="#DFE6F8"
              d="M33 9c7.1 0 13.9-1.1 20.3-3.2H12.7C19.1 7.9 25.9 9 33 9z"
              transform="translate(24 5) translate(8 121)"
            />
          </g>
        </g>
        <path
          fill="#D6DFF6"
          // tslint:disable-next-line: max-line-length
          d="M111.4 19h14.2c.8 0 1.4.4 1.8 1.1.3.7.2 1.5-.2 2.1l-10.6 13.2c-.5.6-.6 1.4-.2 2.1.3.7 1 1.1 1.8 1.1h7.8c.7 0 1.4.4 1.7 1.1.3.7.3 1.4-.1 2l-18 23.5c-.4.5-1 .8-1.6.8h.1c-.6 0-1.2-.3-1.6-.8-.4-.5-.5-1.1-.3-1.7l4.5-15.9c.2-.6 0-1.2-.3-1.7-.4-.5-1.1-.7-2.7-.8h-6.1c-.7 0-1.3-.3-1.6-.9-.4-.6-.4-1.3-.1-1.9l10-22.2c.1-.6.8-1.1 1.5-1.1zM17.7 0h18.2c1 0 1.8.6 2.2 1.4.4.9.3 1.9-.3 2.6L24.4 21c-.6.8-.7 1.8-.3 2.6.4.9 1.3 1.4 2.3 1.4h9.9c.9 0 1.8.5 2.2 1.4.4.8.4 1.8-.2 2.6L15.4 59c-.5.7-1.2 1-2 1h.1c-.8 0-1.5-.4-2-1s-.6-1.4-.4-2.2l5.7-20.3c.2-.8.1-1.6-.4-2.2-.5-.6-1.4-1-3.5-1H5c-.8 0-1.6-.4-2.1-1.1-.5-.7-.5-1.6-.2-2.4L15.5 1.5C15.9.6 16.7 0 17.7 0z"
        />
        <path
          fill="#FFF"
          stroke="#005EE0"
          strokeWidth="2.5"
          // tslint:disable-next-line: max-line-length
          d="M44 72.167c1.105-.829 2.672-.605 3.5.5h0L57.5 86c.325.433.5.96.5 1.5 0 1.38-1.12 2.5-2.5 2.5h0-5c0 8.284 6.716 15 15 15 2.761 0 5 2.239 5 5s-2.239 5-5 5c-13.807 0-25-11.193-25-25h0-5c-.54 0-1.067-.175-1.5-.5-1.104-.828-1.328-2.395-.5-3.5h0l10-13.333c.142-.19.31-.358.5-.5zM65.5 65c13.807 0 25 11.193 25 25h5c1.38 0 2.5 1.12 2.5 2.5 0 .54-.175 1.067-.5 1.5h0l-10 13.333c-.828 1.105-2.395 1.329-3.5.5-.19-.142-.358-.31-.5-.5h0L73.5 94c-.828-1.105-.605-2.672.5-3.5.433-.325.96-.5 1.5-.5h5c0-8.284-6.716-15-15-15-2.761 0-5-2.239-5-5s2.239-5 5-5z"
        />
      </g>
    </svg>
  );
};

export default SuggestRefreshGraphic;
